import React, { useState, useEffect, Fragment } from 'react'
import { Link } from 'react-router'
import { findFacturas, findFilePDF, findFileXML, base64ToBlob, guardarArchivo } from './Fetch/FindFacturas';
import { LoginCheck } from "../Facturas/Fetch/Login";
import { useNavigate } from "react-router";
export default function FindFactura() {

    const [r, setr] = useState({ uuid: '', show: false, arr: [] });
    let navigate = useNavigate();
    useEffect(() => {
        if (localStorage.getItem("ContaKMP")) {

            LoginCheck(localStorage.getItem("ContaKMP")).then(res => {

                if (res === '') {
                    localStorage.removeItem("ContaKMP");
                    navigate("/");

                } else {
                    localStorage.setItem("ContaKMP", res);
                    findFacturas('').then(res => {
                        setr(v => ({
                            ...v,
                            show: true,
                            arr: res
                        }));
                    });
                }

            }).catch(e => {
                console.log(e)
            })
        } else {
            navigate("/");
        }

    }, [navigate])

    const pdfDL = (e, RUUID) => {
        e.preventDefault();
        findFilePDF(RUUID).then(res => {
            const blob = base64ToBlob(res[0].pdf, 'application/pdf');
            guardarArchivo(blob, `${res[0].UUID}.pdf`);
        })
    }

    const xmlDL = (e, RUUID) => {
        e.preventDefault();
        findFileXML(RUUID).then(res => {
            const blob = base64ToBlob(res[0].xml, 'application/xml');
            guardarArchivo(blob, `${res[0].UUID}.xml`);
        })
    }

    const Buscar = (e) => {
        e.preventDefault();
        findFacturas(r.uuid).then(res => {
            setr({
                ...r,
                arr: res
            });
        })
    }

    const LogOut = (e) => {
        e.preventDefault();
        localStorage.removeItem("ContaKMP");
        navigate("/");
    }

    return (
        r.show === false ?
            <div>Loading...</div>
            :
            <table border={1} className={{ display: 'block', float: 'left' }}>
                <thead>
                    <tr>
                        <td colSpan={11}>
                            <form onSubmit={Buscar}>
                            <input placeholder='UUID' size="50" onChange={(e) => setr({
                                ...r,
                                uuid: e.target.value
                            })} />
                            <button type='submit'>Buscar</button>
                            </form>
                        </td>
                        <td colSpan={3}><button onClick={LogOut}>Cerrar Sesion</button></td>
                        <td><button onClick={(e) => {
                            e.preventDefault();
                            navigate("/AddFactura");
                        }}>Agregar</button></td>
                    </tr>
                    <tr>
                        <td rowSpan={2}>UUID</td>
                        <td>Fecha</td>
                        <td rowSpan={2}>Hora</td>
                        <td rowSpan={2}>RFC Emisor</td>
                        <td rowSpan={2}>RFC Receptor</td>
                        <td rowSpan={2}>Descripción</td>
                        <td rowSpan={2}>SubTotal</td>
                        <td rowSpan={2}>Descuento</td>
                        <td rowSpan={2}>IVA</td>
                        <td rowSpan={2}>ISR</td>
                        <td rowSpan={2}>IEPS</td>
                        <td rowSpan={2}>Total</td>
                        <td rowSpan={2} colSpan={2}>Descarga</td>
                        <td rowSpan={2}>Vista PDF</td>
                    </tr>
                    <tr>
                        <td>(Dia-Mes-Año)</td>
                    </tr>
                </thead>
                <tbody>
                   
                    {r.arr.map((el, index) =>
                    <Fragment key={index} >
                        <tr  onClick={(e)=>{}}>
                            <td width={330}>{el.UUID}</td>
                            <td>{el.Fecha}</td>
                            <td>{el.Hora}</td>
                            <td>{el.RFC_Emisor}</td>
                            <td>{el.RFC_Receptor}</td>
                            <td>{el.Descripcion}</td>
                            <td>{el.SubTotal}</td>
                            <td>{el.Descuento}</td>
                            <td>{el.IVA}</td>
                            <td>{el.ISR}</td>
                            <td>{el.IEPS}</td>
                            <td>{el.Total}</td>
                            <td><button onClick={(e) => pdfDL(e, el.UUID)}>PDF</button></td>
                            <td><button onClick={(e) => xmlDL(e, el.UUID)}>XML</button></td>
                            <td><Link to={`/FacturaView/${el.UUID}`} target="_blank" params={{ fromFeed: true }}>Vista</Link></td>
                        </tr>
                          <tr style={{height:0, display:'none'}}>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                         </tr> 
                    </Fragment>
                    )}
                </tbody>
            </table>
    )
}
